const l = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill="currentColor" d="M11.937 10.271a.62.62 0 0 0-.124-.717L8.54 6.22A.76.76 0 0 0 8 6a.76.76 0 0 0-.54.22L4.187 9.554a.62.62 0 0 0-.125.716c.117.24.376.396.663.397h6.546a.73.73 0 0 0 .666-.396"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>';
export {
  l as default
};
